import {AxiosRequestConfig} from 'axios';

import {TEntityValue} from 'modules/data';

export enum ERequestType {
  GET = 'GET',
  HEAD = 'HEAD',
  PUT = 'PUT',
  PATCH = 'PATCH',
  POST = 'POST',
  DELETE = 'DELETE',
}

export type TRequestTableResponseWithPagination<T> = {
    dataTable: T[];
    recordsTotal: number;
}

export interface IFetchDataByIdArgsNumberType {
    id: number;
}

export interface IFetchDataByIdArgs {
    id: string;
}

export interface ISortQuery {
  sorterField?: string;
  sorterOrder?: 'ascend' | 'descend';
}

export interface IPaginationQuery {
  paginationCurrent?: number;
  paginationPageSize?: number;
}

export type TCreateOrUpdateRequestType = ERequestType.POST | ERequestType.PUT;

export type TRequestMessages = {
    successMessage?: string;
    errorMessage?: string;
}

export type TRequestResponse = {
    status: number;
    data: TEntityValue;
    headers: Record<string, string>;
    statusText: string;
    config: AxiosRequestConfig;
    request: XMLHttpRequest;
}
